import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const utilityAssignEmployeeDutyLocaleModule: LocaleModule = {
  name: "utilityAssignEmployeeDuty",
  messages: { en: en, it: it },
};
